import { render, staticRenderFns } from "./ScreenTimeManagementDayPicker.vue?vue&type=template&id=c52c875c&scoped=true&"
import script from "./ScreenTimeManagementDayPicker.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeManagementDayPicker.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTimeManagementDayPicker.vue?vue&type=style&index=0&id=c52c875c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c875c",
  null
  
)

export default component.exports